import React from 'react';

const Logo = () => {
  return (
    <div className="flex items-center justify-between py-3 mt-2 max-w-md md:max-w-2xl mx-auto w-full">
      {/* Especialista */}
      <div className="flex items-center">
        <img 
          src="/assets/images/gestorumimg1.png" 
          alt="Sérgio Stifelmann" 
          className="h-10 w-10 rounded-full object-cover mr-3" 
        />
        <div className="flex flex-col -space-y-1">
          <span className="text-sm font-bold text-gray-800">Sérgio Stifelmann</span>
          <span className="text-xs text-gray-600">Consultor Financeiro</span>
        </div>
      </div>
      
      {/* Logo */}
      <div className="flex items-center">
        <img 
          src="/assets/images/logo_cf.png" 
          alt="Logo Controle Fácil" 
          className="h-16" 
        />
      </div>
    </div>
  );
};

export default Logo;
